<!-- components/icons/MicrosoftIcon.vue -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path fill="#F25022" d="M1 1h10v10H1V1z" />
    <path fill="#00A4EF" d="M1 13h10v10H1V13z" />
    <path fill="#7FBA00" d="M13 1h10v10H13V1z" />
    <path fill="#FFB900" d="M13 13h10v10H13V13z" />
  </svg>
</template>

<script setup>
// No additional script needed
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>